import axiosSecure from '@api/axiosSecure';
import getContextRoot from '@api/getContextRoot';

const listUsers = async (): Promise<any> => {
  const res = await axiosSecure.get(`${getContextRoot()}/user`);
  // const res = await axiosSecure.get(`${getContextRoot()}/user?max=25&offset=0`);
  if (res.data?.users) {
    return res.data.users;
  }
  return res.data;
};

export default listUsers;
